module.exports = __webpack_public_path__ + "img/amjlogo.b8f9d2c2.svg";